module.exports = ".title {\n  font-weight: 700; }\n\n.description {\n  font-size: 21px; }\n\n.acceptButton {\n  border: 0;\n  border-radius: 0.25em;\n  height: 46px;\n  font-size: 17px; }\n\n.rejectButton {\n  background-color: var(--alert);\n  color: var(--white);\n  border: 0;\n  border-radius: 0.25em;\n  height: 46px;\n  font-size: 17px; }\n\n.option {\n  padding: 1em; }\n\n.eye-icon {\n  font-size: 1.5em !important; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/core/switch-property/switch-property.component.scss
// module id = ./src/app/core/switch-property/switch-property.component.scss
// module chunks = main